import React from "react";
import { Checkbox } from "@material-ui/core";
import styled from "styled-components";

const CellWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 0.5em;
    padding: 0.5em 0;
    border-bottom: 1px solid #DADCE0;
    cursor: pointer;
`;

const DropdownFilterCell = ({
  id,
  name,
  option,
  selectedOptions = [],
  setSelectedOptions = () => { },
  checked,
  handleOnCheck = () => { }
}) => (
  <CellWrapper onClick={() => handleOnCheck(id, checked, option, selectedOptions, setSelectedOptions)}>
    <Checkbox checked={checked} onChange={() => handleOnCheck(id, checked, option, selectedOptions, setSelectedOptions)} />
    <div>{name}</div>
  </CellWrapper>
);

export default DropdownFilterCell;
